import {createContext, useContext} from "react";
import type {EncounterLight, EncounterLightOverride, EncounterLightPreview, EncounterLights} from "./EncounterLights.ts";
import type {DirectionalLight} from "@/dungeons/lighting/DirectionalLight.ts";

export type EncounterLightContextValue = {
    state: EncounterLights;
    persistedState: EncounterLights;
    initialLoading: boolean;
    saveOverride: (light: EncounterLightOverride) => Promise<void>;
    deleteOverride: (id: string) => Promise<void>;
    saveLight: (light: EncounterLight) => Promise<void>;
    deleteLight: (id: string) => Promise<void>;
    previewLight: (preview: EncounterLightPreview) => void;
    clearPreview: () => void;
    saveLevelLighting: (levelId: string, light: DirectionalLight) => Promise<void>;
    resetLevelLighting: (levelId: string) => Promise<void>;
    previewLevelLighting: (levelId: string, light: DirectionalLight) => void;
    clearLevelLightingPreview: () => void;
};

export const EncounterLightContext = createContext<EncounterLightContextValue | null>(null);

export function useEncounterLights(): EncounterLightContextValue {
    const value = useContext(EncounterLightContext);
    if (!value) throw new Error("useEncounterLights must be used within EncounterLightProvider");
    return value;
}
